import * as React from 'react';
import { useState } from 'react';
import { CustomReferenceRole, Reference, Part, PartDefinition, ReferenceAssignmentsRequest, selectAllReferenceRoles, getShortTypeName, getUasId, selectAllPartDefinitions, getRefMap, getPartValue, selectCurrentReference, selectReferenceAssignments, selectAllReferences, loadAllTaxonomyReferences, loadAllReferenceAssignments, clearSelectedReference, setSelectedReference } from '../../../redux/TaxonomyReferenceSlice';
import { useAppSelector, useAppDispatch } from '../../../hooks/index';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane, Nav, NavItem, NavLink, FormGroup, Input, FormFeedback, Container, Row, Col, Label, Toast, ToastHeader, ToastBody } from 'reactstrap';
import Select, { useEffect } from 'react-select';
import { Concept, ConceptRef, DimensionalConceptRef } from '../../../redux/ConceptSlice';
import { DtsConcept, loadTaxonomyConcept, resetTaxonomyConceptState, getSelectedTaxonomyConcept } from '../../../redux/TaxonomyConceptSlice';
import enums from '../../../utils/enums';
import { selectEditReference, getTaxonomyChanges, addReferenceRoleChange, TaxonomyChangesState } from '../../../redux/TaxonomyChangesSlice';
import utilityHelper from '../../../utils/utilityHelper';
import { TaxonomyTypeEnum, setIsTaxonomyDirty } from '../../../redux/TaxonomyVersionSlice';
import { Afr, getSelectedAfr } from '../../../redux/AfrSlice';
import { Edit } from '../../../redux/MiscSlice';


import './ModalPopUp.css';
//import Modal, ModalHeader, ModalBody from './Modal';
import Instructions from '../../feature/InstructionsA';
//import { statSync } from 'node:fs';

function AfrFilingInstructionsModal(props: any) {

    const dispatch = useAppDispatch();
    var versionedConcept: DtsConcept | null = useAppSelector(getSelectedTaxonomyConcept);
    const [instructions, setInstructions] = useState<Reference[]>([]);
    const [activeTab, setActiveTab] = useState("1");
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const sectionAliases: any = {
        Fiduciary_Revenues: "Additions",
        Fiduciary_Expenditures: "Deductions",
        Proprietary_Revenues: "Operating and Non-Operating Revenues",
        Proprietary_Expenditures: "Operating and Non-Operating Expenditures"
    };
    const loadInstructionsConcept = function () {
        var taxYear = new Date().getFullYear();
        if (currentAfr) {
            taxYear = currentAfr.year
        }
        var ref: ConceptRef = {
            conceptId: props.source,
            taxonomyType: TaxonomyTypeEnum.AFR,
            afrYear: taxYear
        }
        dispatch(loadTaxonomyConcept(ref));
    }
    const generateInstructionReferences = function (dtsc: DtsConcept | null) {
        var instructionSet: Reference[] = [];
        if (dtsc && dtsc.concept && dtsc.concept.references) {
            dtsc.concept.references.map(r => {
                if (r.type.indexOf("instruct") > 0) {
                    instructionSet.push(r);
                }
            });
        }
        return instructionSet;
    }
    const getAliasedSection = function (r: Reference): string {
        var result: string = getPartValue(r, "Section");
        if (props.hasOwnProperty("fundGroup")) {
            var aliasKey = props.fundGroup + "_" + result;
            if (sectionAliases.hasOwnProperty(aliasKey)) {
                result = sectionAliases[aliasKey];
            }
        }
        return result;
    }
    const toggle = (tab: string) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }

    React.useEffect(() => {
        setInstructions(generateInstructionReferences(versionedConcept));
    }, [versionedConcept]);

    React.useEffect(() => {
        loadInstructionsConcept();
    }, []);

    return (
        <React.Fragment >
            <Modal size="xl" isOpen={props.isOpen} onClose={props.onCloseModal}>
                <ModalHeader>AFR Filing Instructions ({props.fundGroup.replace("Component","Discrete Component")})</ModalHeader>
                <ModalBody>
                    <div>
                        <Nav tabs>
                            {instructions.map((r, idx) =>
                                <NavItem>
                                    <NavLink
                                        className={activeClass("" + (idx + 1))}
                                        onClick={() => { toggle("" + (idx + 1)); }}
                                    >
                                        {getAliasedSection(r)}
                                    </NavLink>
                                </NavItem>
                            )}
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            {instructions.map((r, idx) =>
                                <TabPane tabId={"" + (idx + 1)}>
                                    <Row>
                                        <Col sm="12">
                                            <div dangerouslySetInnerHTML={{ __html: getPartValue(r, "Article") }} ></div>
                                        </Col>
                                    </Row>
                                </TabPane>
                            )}
                        </TabContent>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={props.onCloseModal}>Close</Button>
                </ModalFooter>
            </Modal>
        </React.Fragment >
    );
}

export default AfrFilingInstructionsModal;